module.exports = "function rule(user, context, callback) {\n  if (context.clientName === 'TheAppToCheckAccessTo') {\n    var d = new Date().getDay();\n\n    if (d === 0 || d === 6) {\n      return callback(new UnauthorizedError('This app is available during the week'));\n    }\n  }\n  callback(null, user, context);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/pages/jp/homepage/rule-templates/only-allow-weekdays.js.txt
// module id = 1441
// module chunks = 0